"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxBatch = exports._EmptyQuery = void 0;
exports._EmptyQuery = Object.freeze({ where: {} });
exports.maxBatch = 500;
